import { gql } from 'graphql-request';

const PAYMENT_ACCOUNT_FIELDS = `
  last4
  status
  connectedAt
`;

export const myPaymentAccountQuery = gql`
  query myPaymentAccount {
    myPaymentAccount {
      ${PAYMENT_ACCOUNT_FIELDS}
    }
  }
`;

export const connectNmiAccountMutation = gql`
  mutation connectNmiAccount($input: ConnectNmiAccountInput!) {
    connectNmiAccount(input: $input) {
      ${PAYMENT_ACCOUNT_FIELDS}
    }
  }
`;

export const disconnectNmiAccountMutation = gql`
  mutation disconnectNmiAccount {
    disconnectNmiAccount
  }
`;

const MerchantPaymentAccountGraphQL = {
  queries: {
    myPaymentAccount: myPaymentAccountQuery,
  },
  mutations: {
    connectNmiAccount: connectNmiAccountMutation,
    disconnectNmiAccount: disconnectNmiAccountMutation,
  },
};

export default MerchantPaymentAccountGraphQL;
